import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";
import type {
  CfDashboardRangeParams,
  CfDashboardSummaryResponse,
} from "./types";

const base = `${config.apiUrl}/cf-dashboard`;

export const cfDashboardApi = {
  summary(params?: CfDashboardRangeParams): Promise<CfDashboardSummaryResponse> {
    const q = new URLSearchParams();
    if (params?.from) q.set("from", params.from);
    if (params?.to) q.set("to", params.to);
    if (params?.presetDays != null)
      q.set("presetDays", String(params.presetDays));
    const qs = q.toString();
    return fetcher.get(`${base}/summary${qs ? `?${qs}` : ""}`);
  },
};
